import { Component as PComponent } from "preact";
import PropTypes from "prop-types";
import { withStoreConnection } from "../../components";
import { locationSelector } from "../../../store/selectors/selectors";
import { ArrayUtils, get } from "@green24/npm-javascript-utils";
import { M_Location } from "../../../models/Models_Location";
import withConfiguration from "./withConfiguration";

/**
 * A public higher-order component to access the imperative API
 */
export const withStorageUnit = Component => {
	class HOC extends PComponent {
		render({location, configuration, unitID}) {
			const storageUnitID = unitID || configuration.unitID;
			const unit = ArrayUtils.findByID(get(location, "storageUnits", []), storageUnitID);

			return (
				<Component
					unitID={storageUnitID}
					unit={unit}
					{...this.props}
				/>
			);
		}

		static get displayName() {
			return "withStorageUnit(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}

		static get propTypes() {
			return {
				unitID: PropTypes.number,

				//Store
				location: PropTypes.object,

				//withConfiguration
				configuration: PropTypes.object,
			}
		}

		static get defaultProps() {
			return {
				location: M_Location,
			}
		}
	}

	const mapStateToProps = state => {
		return {
			location: locationSelector.selectData(state),
		};
	};

	return withStoreConnection(mapStateToProps)(withConfiguration(HOC));
};

export default withStorageUnit;
